import React from 'react';
import { handleActions } from 'redux-actions';
import * as ActionTypes from '../../../constants/ActionTypes';
import { merge, set as setPath } from 'lodash';

const carouselDataStoreDefaults = {
    general: {
        backgroundColor: '#000000'
    },
    caption: {
        color: '#CBCBCB',
        size: '16px',
        style: 'normal',
        weight: 'bold',
        decoration: 'none',
        lineHeight: '1.0',
        align: 'left',
        font: 'IBM Plex Sans'
    },
    closeIcon: {
        color: '#CBCBCB',
        hoverColor: '#FFFFFF'
    }
};

const carouselDataReducer = handleActions(
    {
        //TODO: temporary partial implementation of global reducer
        [ActionTypes.THEME_MODIFY_KEY]: (state, action) => {
            let pathCheck = action.path.split('.');
            if (pathCheck[0] === 'gallery') {
                return merge({}, state, setPath({}, pathCheck, action.value));
            } else {
                return state;
            }
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (action.theme.hasOwnProperty('gallery')) {
                return { ...state, gallery: action.theme.gallery };
            } else {
                return state;
            }
        }
    },
    carouselDataStoreDefaults
);

export default carouselDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/carousel.js